import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video-gallery',
  templateUrl: './video-gallery.component.html',
  styleUrls: ['./video-gallery.component.scss']
})
export class VideoGalleryComponent implements OnInit {

  selectedLang: any;

  videoList: { link: SafeResourceUrl; description: string, isYoutubeLink: boolean }[] = [];

  constructor(
    private translateService: TranslateService,
    private location: Location,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // if (localStorage.getItem('lang')) {
    //   this.selectedLang = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : ''
    //   this.translateService.use(this.selectedLang.code)
    // }
    this.loadVideoList();
  }

  onChildValueChanged(value){
    // console.log(value)
    // if (value?.code == 'en') {
    //   // this.lanTranslate('en')
    // } else if (value?.code == 'hd') {
    //   // this.lanTranslate('hd')
    // }
  }

  goBack(): void {
    this.location.back();
  }

  loadVideoList() {
    const rawVideoList = [
      {
        link: 'https://drive.google.com/file/d/1N3vHHXLOelD-SNQbIVGmTLzEUmvPx28F/preview',
        description: 'Atal Bhujal Yojana, Fatehabad',
        isYoutubeLink: false
      },
      {
        link: 'https://drive.google.com/file/d/1vvYqwnMFho_laiVNwsfoTtNPFsqoz1YJ/preview',
        description: 'Data Dissemination DLI#1, Gurugram & Bhiwani',
        isYoutubeLink: false
      },
      {
        link: 'https://drive.google.com/file/d/17FUHZUCzE6_IYw_932410FYdruhcaAVs/preview',
        description: 'Success of Convergence, Yamunanagar',
        isYoutubeLink: false
      },
      {
        link: 'https://drive.google.com/file/d/1vQGxQOL-inU6OGN2-yOHv2m70daInm_t/preview',
        description: 'DSR Video, Karnal',
        isYoutubeLink: false
      },
      {
        link: 'https://drive.google.com/file/d/15cyvl6gHnXCMg2TEGrbqgiaP2wQy_N2X/preview',
        description: 'Success Story, Gurugram',
        isYoutubeLink: false
      },
      {
        link: 'https://drive.google.com/file/d/1iIN5kHjarOqRRarIXDIYIkR5487fZeaZ/preview',
        description: 'Women Warrior, Yamunanagar',
        isYoutubeLink: false
      },
      {
        link: 'https://drive.google.com/file/d/1_vIYiKe4kOEIlGV8oHTzXbdeIo70IIGo/preview',
        description: 'IEC Interventions, Gurugram',
        isYoutubeLink: false
      },
      {
        link: 'https://drive.google.com/file/d/1pf-oCfNdrGLn-LvYh2onsDCfyJcxTC2G/preview',
        description: 'Water Conservation, Mahendragarh',
        isYoutubeLink: false
      },
      {
        link: 'https://drive.google.com/file/d/1zcBDLZ6csWx1-upqcE2Oqhse1orHlFVJ/preview',
        description: 'IISIF, Mahendragarh',
        isYoutubeLink: false
      },
      {
        link: 'https://www.youtube.com/embed/aFG9zsm-Rxw',
        description: 'District Karnal MI SCHEME',
        isYoutubeLink: true
      },
      {
        link: 'https://www.youtube.com/embed/i6Pc5StsWtA',
        description: 'Drip irrigated wheat in the field of Devi Lal Godara, Mangali Suratiya, Hisar, 12.01.24',
        isYoutubeLink: true
      },
      {
        link: 'https://www.youtube.com/embed/LmA9pXU0uYs',
        description: 'Everything you need to know about MICADA- A complete overview',
        isYoutubeLink: true
      },
      {
        link: 'https://www.youtube.com/embed/p5XYu5QQdzY',
        description: 'Jhajjar Video 2024-12-03 at 4.57.45 PM',
        isYoutubeLink: true
      },
      {
        link: 'https://www.youtube.com/embed/Yb5Elz7dGrE',
        description: 'Maximizing Sugarcane Yield- The powe of Micro Irrigation in fields',
        isYoutubeLink: true
      },
      {
        link: 'https://www.youtube.com/embed/BK6nxhGbhTU',
        description: 'MI Infrastructure at RD 11000-L Deewana Disty',
        isYoutubeLink: true
      },
      {
        link: 'https://www.youtube.com/embed/TBLfB4l6qnE',
        description: 'RD- 14365L BHANDOR DISTY',
        isYoutubeLink: true
      },
      {
        link: 'https://www.youtube.com/embed/smoUp-KHCYA',
        description: 'Rinku Kumar from Yamunanagar- Real results with MI',
        isYoutubeLink: true
      },
      {
        link: 'https://www.youtube.com/embed/aFG9zsm-Rxw',
        description: 'District Karnal MI SCHEME',
        isYoutubeLink: true
      },
      {
        link: 'https://www.youtube.com/embed/rXdKXflfc-o',
        description: 'Micro Irrigation Project at outlet 25220/L Sandhola Minor, Teh Pehowa, Distt Kurukshetra, Haryana.',
        isYoutubeLink: true
      },
    ]

    this.videoList = rawVideoList.map(video => ({
      link: this.sanitizer.bypassSecurityTrustResourceUrl(video.link),
      description: video.description,
      isYoutubeLink: video.isYoutubeLink
    }));
  }

}

